module.exports = __webpack_public_path__ + "static/img/mini-saving.75f5b307.svg";